export const tagsParser = (tagList) => {
  if (tagList?.length > 0) {
    const tagFilters = tagList?.toString().replaceAll(",", ";");
    return tagFilters;
  }
  return "";
};
